import {Formik} from 'formik'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useState} from 'react'
import {NullAsDefault, shallowDiff} from 'views/Shared'
import {Pure} from "../../../../components/Pure";
import {createControlledFormField} from "../../factory/createFormField";
import {createValue} from "../../../../components/form/utils";
import TextArea from "antd/lib/input/TextArea";
import {compose, fromRenderProps, mapProps, pure} from "recompose";
import withTranslate from "../../../../modules/local/withTranslate";
import {SelectWidget} from "../../custom/ReactSelectComponents";
import {FeedbackCategoryAsyncWrapper} from "./FeedbackCategoryAsyncWrapper";
import getTitle from "../../../../helpers/getTitle";
import getAvatar from "../../../../helpers/getAvatar";
import {getId, getType} from "../../../../apis/model/base";
import {Avatar, Image, Input, message, Radio, Select, Upload} from "antd";
import {HeaderWithIconLine} from "../../Templates/items/ListHeader";
import {deepTranslate, renderIf} from "../../../Shared";
import {BsPersonFill} from "react-icons/bs";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {ItemInformation} from 'components/common/ItemInformation'
import {appFieldTypes, StatusTypes} from "../../appFieldTypes";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {GoDotFill} from "react-icons/go";
import classNames from "classnames";
import {LoginContext} from "../../../../components/LoginContext";
import {ProfileCompact} from "../../Profile/functions/renderProfile";
import {ChurchItemCompact} from "../../Church/functions/renderChurch";
import {PiChatCircleTextFill, PiMusicNotesFill, PiPlusBold} from "react-icons/pi";
import {IoImageOutline} from "react-icons/io5";
import {FaBookBible} from "react-icons/fa6";
import {formatDate} from "../../../../helpers/datetimeHelpers";
import {Field, FormActions, Section} from "components/form/ModernForm";
import {callApi} from "modules/asyncCache/callApi";
import {image_upload_Api} from "apis";
import {notifyOnError} from "../../factory/createErrorEvent";


const formSchema = {
    feedback_category: {
        title: 'your issue is',
        children: [
            {
                name: 'feedback_category_id',
                component: compose(
                    withTranslate,
                    fromRenderProps(FeedbackCategoryAsyncWrapper, ({items, isLoading}) => {
                        const options = Array.from(items).map((option) => {
                            return {
                                value: getId(option),
                                label: getTitle(option),
                            }
                        })
                        return ({options})
                    }),
                    mapProps(({name, value, translate, onChange, options}) => {
                        return {
                            name,
                            value,
                            allowClear: true,
                            className: 'w-full',
                            placeholder: translate('click to select'),
                            options: options,
                            onChange: (value) => {
                                onChange(createValue(name, value))
                            },
                        }
                    }),
                    pure
                )(SelectWidget),
            },
        ],
    },
    title: {
        title: 'title',
        className: '333-777',
        children: [
            {
                name: 'title',
                component: createControlledFormField({
                    placeholder: 'title',
                }),
            },
        ],
    },
    description: {
        title: 'description',
        children: [
            {
                name: 'description',
                component: createControlledFormField({
                    placeholder: 'description',
                    className: 'scrollBarThin custom-area-count',
                    Component: TextArea,
                    showCount: true,
                    maxLength: 1000,
                    autoSize: {minRows: 3, maxRows: 6},
                }),
            },
        ],
    },
    name: {
        title: 'full name',
        children: [
            {
                name: 'name',
                component: createControlledFormField({
                    placeholder: 'full name',
                    withValues: ({login}) => {
                        return ({
                            disabled: !!login?.name,
                        })
                    },
                }),
            },
        ],
    },
    phone_email: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
        itemClassNames: ['col-span-1', 'col-span-1 md:col-span-2'],
        children: [
            {
                label: 'phone',
                name: 'phone',
                component: createControlledFormField({
                    type: 'tel',
                    placeholder: 'phone',
                    withValues: ({login}) => ({
                        disabled: !!login?.phone_number,
                    }),
                }),
            },
            {
                label: 'email',
                name: 'email',
                component: createControlledFormField({
                    type: 'email',
                    placeholder: 'email',
                    withValues: ({login}) => ({
                        disabled: !!login?.email,
                    }),
                }),
            },
        ],
    },

    reply_title: {
        title: 'response title',
        children: [
            {
                name: 'reply_title',
                component: createControlledFormField({
                    placeholder: 'response title',
                }),
            },
        ],
    },
    reply_description: {
        title: 'response content',
        children: [
            {
                name: 'reply_description',
                component: createControlledFormField({
                    placeholder: 'response content',
                    className: 'scrollBarThin custom-area-count',
                    Component: TextArea,
                    showCount: true,
                    maxLength: 1000,
                    autoSize: {minRows: 3, maxRows: 6},
                }),
            },
        ],
    },
    status: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                label: 'status',
                name: 'status',
                component: ({name, value, form, onChange}) => {
                    const options = Array.from(form?.values?.status_options ?? [])
                    return (
                        <Radio.Group
                            name={name}
                            value={value}
                            options={options}
                            onChange={onChange}
                            optionType="button"
                            buttonStyle="solid"
                            className="custom-radio-button"
                        />
                    )
                },
            },
            {
                label: 'public',
                name: 'public',
                component: ({name, value, form, onChange}) => {
                    const options = Array.from(form?.values?.public_options ?? [])
                    return (
                        <Radio.Group
                            name={name}
                            value={value}
                            options={options}
                            onChange={onChange}
                            optionType="button"
                            buttonStyle="solid"
                            className="custom-radio-button"
                        />
                    )
                },
            },
        ],
    },

}

// Gallery hình ảnh người dùng đính kèm feedback - dùng chung cho DetailForm (xem chi tiết) và
// EditFeedbackForm (modal trả lời), phía admin/platform xem để hỗ trợ ngược lại người dùng.
// Image.PreviewGroup cho phép bấm phóng to xem từng ảnh.
export const FeedbackPhotoGallery = ({photos = []}) => {
    if (!photos?.length) return null
    return (
        <Image.PreviewGroup>
            <div className="flex flex-wrap gap-2">
                {photos.map((photo) => (
                    <Image
                        key={photo.id}
                        src={photo.path}
                        width={72}
                        height={72}
                        style={{objectFit: 'cover', borderRadius: 8}}
                        className="border border-color-100"
                    />
                ))}
            </div>
        </Image.PreviewGroup>
    )
}

export const DetailForm = ({item, onCancel}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    const {
        title,
        description,
        user,
        phone,
        email,
        name,
        feedback_category,
        created,
        ref,
        photos = [],
        reply_title,
        reply_description,
        status,
        updated,
    } = item ?? {}

    const ItemContent = ({inline = false, showIcon = false, label, value, fontSize = 'text-sm', textClass = 'text-color-100'}) => (
        <div className={classNames('', fontSize, inline === true ? 'space-x-1' : 'flex flex-col')}>
            {renderIf(
                showIcon === true,
                <GoDotFill size={10} className="text-color-400"/>
            )}
            <span className="text-color-400 italic">{`${t(label)} : `}</span>
            <span className={classNames("", textClass, inline === false && 'ml-3')}>
                {value}
            </span>
        </div>
    )

    const renderSender = () => {
        if (user) {
            return (
                <div className="ml-4 flex items-center gap-2">
                    <Avatar
                        size={26}
                        icon={<BsPersonFill size={16} className="text-color-500"/>}
                        src={user?.avatar}
                        className="flex flex-center background-200"
                    />
                    <Link to={getLinkToDetail(user)}
                          className="flex-1 font-semibold text-sm text-color-100 no-underline leading-tight">
                        {user?.name}
                    </Link>
                </div>
            )
        } else if (name) {
            return (
                <div className="ml-4 flex flex-col gap-1 flex-1">
                    <ItemInformation label="full name" value={name} className="text-sm"/>
                    <div className="flex items-center gap-6">
                        <ItemInformation label="phone" value={phone} className="text-sm"/>
                        <ItemInformation label="email" value={email} className="text-sm"/>
                    </div>
                </div>
            )
        }
        return (
            <div className="flex items-center gap-3">
                <GoDotFill size={10} className="text-color-400"/>
                <span className="font-medium text-xs text-color-300 leading-tight">
                    {`${t('anonymous user')} *`}
                </span>
            </div>
        )
    }

    const renderRef = (ref) => {

        let _itemRender

        switch (getType(ref)) {
            case 'church':
                _itemRender = <ChurchItemCompact item={ref}/>
                break
            case 'profile':
                _itemRender = <ProfileCompact item={ref}/>
                break
            case 'codi_document':
                const {document_type, language} = ref ?? {}
                _itemRender = (
                    <div className="flex items-center gap-3 custom-render-border rounded-lg relative">
                        <Avatar
                            size={60}
                            icon={<FaBookBible size={30} className="text-primary-400"/>}
                            className="flex flex-center bg-primary-50 rounded-l-lg rounded-r-0"
                        />
                        <div className="py-1 flex flex-col flex-1">
                            <Link to={getLinkToDetail(ref)} target="_blank" className="font-bold text-color-000 no-underline leading-snug mb-1">
                                {getTitle(ref)}
                            </Link>
                            <div className="flex items-center gap-x-2 md:gap-x-6">
                                <div className="flex items-baseline gap-1 leading-tight">
                                    <span className="text-xs text-color-500 italic">{`${t('document type')} : `}</span>
                                    <span className="font-medium text-xs text-blue-500 italic">
                                        {document_type?.title}
                                    </span>
                                </div>
                                <ItemInformation label="language" value={t(language)} className="text-xs" />
                            </div>
                        </div>
                        <span
                            style={{ height: 20, fontSize: 10, padding: '0 10px'}}
                            className="absolute right-5 flex flex-center bg-orange-50 rounded-full font-medium text-orange-500 italic leading-tight">
                            {t(getType(ref))}
                        </span>
                    </div>
                )
                break
            case 'music':
                const {music_authors = [], music_types = []} = ref ?? {}
                _itemRender = (
                    <div className="flex items-center gap-3 custom-render-border rounded-lg relative">
                        <Avatar
                            size={60}
                            icon={<PiMusicNotesFill size={30} className="text-primary-400"/>}
                            className="flex flex-center bg-primary-50 rounded-l-lg rounded-r-0"
                        />
                        <div className="py-1 flex flex-col flex-1">
                            <Link to={getLinkToDetail(ref)} target="_blank" className="font-bold text-color-000 no-underline leading-snug">
                                {getTitle(ref)}
                            </Link>
                            {renderIf(
                                music_authors.length > 0,
                                <div className="flex items-baseline gap-1 leading-tight">
                                    <span className="text-xs text-color-500 italic">{`${t('author')} : `}</span>
                                    {music_authors.map((e, i) => (
                                        <span key={i} className="font-medium text-xs text-color-100 italic">
                                            {e.fullname} {i < music_authors.length - 1 && ' - '}
                                        </span>
                                    ))}
                                </div>
                            )}
                            {renderIf(
                                music_types.length > 0,
                                <div className="flex items-baseline gap-1 leading-tight">
                                    <span className="text-xs text-color-500 italic">{`${t('music types')} : `}</span>
                                    {music_types.map((e, i) => (
                                        <span key={i} className="font-medium text-xs text-blue-500 italic">
                                            {e.title} {i < music_types.length - 1 && ' - '}
                                        </span>
                                    ))}
                                </div>
                            )}
                        </div>
                        <span
                            style={{ height: 20, fontSize: 10, padding: '0 10px'}}
                            className="absolute right-5 flex flex-center bg-orange-50 rounded-full font-medium text-orange-500 italic leading-tight">
                            {t(getType(ref))}
                        </span>
                    </div>
                )
                break
            default:
                const {description, container, owner} = ref ?? {}
                _itemRender = (
                    <div className="p-2 flex items-center gap-3 custom-render-border relative">
                        <div className="flex flex-col flex-1">
                            <Link to={getLinkToDetail(ref)} target="_blank" className="font-bold text-color-000 no-underline leading-snug mb-1">
                                {description}
                            </Link>
                            <div className="flex items-baseline gap-x-1 text-xs text-color-500 italic">
                                <Link to={getLinkToDetail(owner)} className="font-bold text-color-100 no-underline">
                                    {getTitle(owner)}
                                </Link>
                                <span className="whitespace-no-wrap">{t('posted on channel')}</span>
                                <Link to={getLinkToDetail(container)} className="font-semibold text-green-600 no-underline">
                                    {getTitle(container)}
                                </Link>
                            </div>
                        </div>
                        <span
                            style={{ height: 20, fontSize: 10, padding: '0 10px'}}
                            className="absolute right-5 flex flex-center bg-orange-50 rounded-full font-medium text-orange-500 italic capitalize leading-tight">
                            {t(getType(ref))}
                        </span>
                    </div>
                )
                break

        }
        return _itemRender
    }

    return (
        <div className="flex flex-col gap-6">
            {renderIf(
                ref,
                renderRef(ref)
            )}
            <div className="flex flex-col gap-2">
                <HeaderWithIconLine
                    icon={ <GoDotFill size={14} className="text-color-500" /> }
                    title="content"
                    className="text-color-300"
                />
                <div className="ml-3 flex flex-col gap-2">
                    <ItemContent label="header" value={title} textClass="font-semibold text-color-000"/>
                    <ItemContent label="description" value={description} textClass="font-normal text-color-300"/>
                    <ItemContent
                        inline={true}
                        showIcon={true}
                        fontSize="text-xs"
                        label="category"
                        value={feedback_category?.title}
                        textClass="font-medium text-blue-500"
                    />
                    <ItemContent
                        inline={true}
                        showIcon={true}
                        fontSize="text-xs"
                        label="send at"
                        value={formatDate(created, 'HH:mm - DD/MM/YYYY')}
                        textClass="font-medium text-color-000 italic"
                    />
                    <div className="flex flex-col gap-1 text-xs">
                        {renderIf(
                            _.some([user, name]),
                            <div className="space-x-1">
                                <GoDotFill size={10} className="text-color-400"/>
                                <span className="text-color-400 italic">{`${t('creator')} : `}</span>
                            </div>
                        )}
                        {renderSender()}
                    </div>
                </div>
            </div>
            {renderIf(
                photos.length > 0,
                <div className="flex flex-col gap-2">
                    <HeaderWithIconLine
                        icon={ <GoDotFill size={10} className="text-color-400" /> }
                        title="attached image"
                        className="text-sm text-color-400"
                    />
                    <div className="ml-3">
                        <FeedbackPhotoGallery photos={photos}/>
                    </div>
                </div>
            )}
            {renderIf(
                _.some([reply_title, reply_description]),
                <div className="flex flex-col gap-2">
                    <HeaderWithIconLine
                        icon={ <GoDotFill size={10} className="text-color-400" /> }
                        title="responses"
                        className="text-sm text-color-400"
                    />
                    <div className="ml-3 flex flex-col gap-2">
                        <ItemContent inline={true} label="header" value={reply_title}
                                     textClass="font-semibold text-color-000"/>
                        <ItemContent label="description" value={reply_description}
                                     textClass="font-normal text-color-300"/>
                        <ItemContent
                            showIcon={true}
                            inline={true}
                            fontSize="text-xs"
                            label="responses at"
                            value={formatDate(updated, 'HH:mm - DD/MM/YYYY')}
                            textClass="font-medium text-color-100 italic"
                        />
                    </div>
                </div>
            )}
            <div className="flex justify-end p-3 mt-6">
                <span onClick={onCancel} className="font-medium text-color-200 hover:text-color-000 cursor-pointer">
                    {t('close')}
                </span>
            </div>
        </div>
    )
}

const FEEDBACK_MAX_PHOTOS = 5

// Cùng mẫu customRequest -> callApi(image_upload_Api) trực tiếp như PicturesWall
// (src/views/CreateImagePost/CreateImagePost.js) - đây là ngoại lệ được phép gọi callApi()
// thẳng thay vì qua useAsyncAction, chỉ áp dụng cho luồng upload file/ảnh.
// disk=local: ảnh feedback lưu local trên server thay vì GCS (xem
// Modules/Image/Http/Controllers/ImageController@upload phía backend).
const FeedbackPhotoUpload = ({value, onChange}) => {
    const t = useTranslate()
    // fileList giữ ở local state (giống PicturesWall) và cập nhật ở MỌI lần onChange, kể cả lúc
    // status vẫn là 'uploading' - antd tự sinh thumbUrl bất đồng bộ từ originFileObj và bắn thêm
    // 1 onChange nữa khi có; nếu chỉ nhận cập nhật lúc status !== 'uploading' (như bản đầu) thì
    // card ảnh không được track liên tục nên thumbnail/tiến trình không hiện ra - đã gặp thực tế.
    const [fileList, setFileList] = useState(Array.isArray(value) ? value : [])

    const beforeUpload = (file) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
        if (!isJpgOrPng) {
            message.error(t('only png or jpg images are supported'))
            return Upload.LIST_IGNORE
        }
        const isLt5M = file.size / 1024 / 1024 < 5
        if (!isLt5M) {
            message.error(`${t('image must smaller than')} 5MB!`)
            return Upload.LIST_IGNORE
        }
        return true
    }

    return (
        <div className="flex flex-col gap-1.5">
            <Upload
                multiple
                accept=".jpg,.jpeg,.png"
                listType="picture-card"
                fileList={fileList}
                beforeUpload={beforeUpload}
                customRequest={({onSuccess, onError, file}) => {
                    callApi({
                        apiInfo: image_upload_Api,
                        values: {
                            'photos[]': file,
                            owner_type: 'feedback',
                            disk: 'local',
                        },
                    })
                        .then((res) => {
                            if (res?.error) {
                                notifyOnError(t)(res.error, res.errorMessages)
                                onError(res.error)
                            } else {
                                onSuccess(res)
                            }
                        })
                        .catch(onError)
                }}
                onChange={({fileList: nextFileList}) => {
                    setFileList(nextFileList)
                    onChange(nextFileList)
                }}>
                {fileList.length >= FEEDBACK_MAX_PHOTOS ? null : (
                    <div className="flex flex-col gap-1 items-center">
                        <PiPlusBold size={15} className="text-color-400"/>
                        <div className="text-xs font-medium text-color-300">{t('add photo')}</div>
                    </div>
                )}
            </Upload>
            <span className="text-2xs text-color-400 italic">
                {t('up to 5 png or jpg images to help us assist you')}
            </span>
        </div>
    )
}

export const CreateFeedbackForm = ({
    className = '',
    initValues = {},
    onCancel = NullAsDefault,
    onSubmit = NullAsDefault,
}) => {
    const t = useTranslate()
    const login = useContext(LoginContext)
    const {isSm} = useContext(LayoutContext)

    const initialValues = {
        login,
        feedback_category_id: undefined,
        title: undefined,
        description: undefined,
        name: login?.name,
        email: login?.email,
        phone: login?.phone_number,
        photo_files: [],
        ...initValues,
    }

    // photo_files vẫn 'uploading' (chưa có file.response.data.ids) mà submit ngay thì photoIds rút
    // ra rỗng - feedback vẫn tạo được (title/description lưu bình thường) nhưng KHÔNG có ảnh nào
    // được gắn vào, ảnh đã lên server thành Photo mồ côi (owner_id=null, không ai trỏ tới) - đúng
    // lỗi "không lưu được ảnh lúc tạo feedback" đã gặp thực tế. Chặn ngay trong validate (không chỉ
    // disable nút Submit) để Enter trong input cũng không lách qua được.
    const validate = (values) => {
        const errors = {}
        if (!values.title?.trim()) errors.title = t('required field')
        if (!values.description?.trim()) errors.description = t('required field')
        if ((values.photo_files || []).some((f) => f.status === 'uploading')) {
            errors.photo_files = t('please wait for photo upload to finish')
        }
        return errors
    }

    return (
        <Formik
            initialValues={initialValues}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            onSubmit={(values) => {
                const {photo_files, ...rest} = values
                // callApi() bọc response gốc (defaultTransform) theo nhiều lớp khác nhau tuỳ version
                // - thử lần lượt các đường dẫn khả dĩ thay vì tin chắc 1 đường duy nhất, tránh rớt
                // ảnh âm thầm (feedback vẫn tạo được, chỉ là không có ảnh) nếu shape lệch đi.
                const photoIds = (photo_files || [])
                    .map((file) => (
                        _.get(file, 'response.data.ids.0') ||
                        _.get(file, 'response.result.ids.0') ||
                        _.get(file, 'response.ids.0')
                    ))
                    .filter(Boolean)
                onSubmit(_.omitBy({
                    ...rest,
                    photos: photoIds.length > 0 ? photoIds.join(',') : undefined,
                }, _.isUndefined))
            }}>
            {({values, errors, touched, setFieldValue, handleSubmit, isValid, isSubmitting}) => (
                <form onSubmit={handleSubmit} className={classNames('flex flex-col gap-4', className)}>

                    <Section icon={PiChatCircleTextFill} title={t('content feedback')} theme="highlight">
                        <Field label={t('your issue is')}>
                            <Pure>
                                <FeedbackCategoryAsyncWrapper>
                                    {({items, isLoading, onSearch}) => (
                                        <Select
                                            value={values.feedback_category_id}
                                            onChange={(v) => setFieldValue('feedback_category_id', v)}
                                            onSearch={onSearch}
                                            showSearch
                                            filterOption={false}
                                            loading={isLoading}
                                            allowClear
                                            placeholder={t('click to select')}
                                            className="w-full"
                                            options={items.map(i => ({value: getId(i), label: getTitle(i)}))}
                                        />
                                    )}
                                </FeedbackCategoryAsyncWrapper>
                            </Pure>
                        </Field>
                        <Field label={t('title')} required error={touched.title && errors.title}>
                            <Input
                                value={values.title}
                                onChange={(e) => setFieldValue('title', e.target.value)}
                                placeholder={t('title')}
                                className="rounded-xl"
                                allowClear
                            />
                        </Field>
                        <Field label={t('description')} required error={touched.description && errors.description}>
                            <TextArea
                                value={values.description}
                                onChange={(e) => setFieldValue('description', e.target.value)}
                                placeholder={t('description')}
                                autoSize={{minRows: 3, maxRows: 6}}
                                maxLength={1000}
                                showCount
                                className="scrollBarThin custom-area-count"
                            />
                        </Field>
                    </Section>

                    <Section icon={IoImageOutline} title={t('attach photos')} subtitle={t('optional')}>
                        <FeedbackPhotoUpload
                            value={values.photo_files}
                            onChange={(fileList) => setFieldValue('photo_files', fileList)}
                        />
                        {renderIf(
                            errors.photo_files,
                            <span className="text-2xs text-rose-600">{errors.photo_files}</span>
                        )}
                    </Section>

                    <Section
                        icon={BsPersonFill}
                        title={t('information sender')}
                        subtitle={login ? undefined : t('optional')}>
                        {login ? (
                            <div className="flex items-center gap-3 px-3 py-2.5 background-50 rounded-xl border border-color-50">
                                <Avatar
                                    size={34}
                                    src={getAvatar(login)}
                                    icon={<BsPersonFill size={16} className="text-color-400"/>}
                                    className="flex flex-center background-200 flex-shrink-0"
                                />
                                <div className="flex flex-col gap-0.5 flex-1 min-w-0">
                                    <span className="font-semibold text-sm text-color-000 leading-none truncate">
                                        {login?.name}
                                    </span>
                                    <span className="text-xs text-color-400 italic truncate">
                                        {login?.email || login?.phone_number}
                                    </span>
                                </div>
                                <span
                                    style={{padding: '2px 8px'}}
                                    className="flex-shrink-0 text-2xs font-semibold text-green-600 bg-green-50 rounded-full">
                                    ✓ {t('logged in')}
                                </span>
                            </div>
                        ) : (
                            <div className="flex flex-col gap-3">
                                <Field label={t('full name')}>
                                    <Input
                                        value={values.name}
                                        onChange={(e) => setFieldValue('name', e.target.value)}
                                        placeholder={t('full name')}
                                        className="rounded-xl"
                                    />
                                </Field>
                                <div className={classNames('grid gap-2', isSm ? 'grid-cols-1' : 'grid-cols-2')}>
                                    <Field label={t('phone')}>
                                        <Input
                                            value={values.phone}
                                            onChange={(e) => setFieldValue('phone', e.target.value)}
                                            placeholder={t('phone')}
                                            type="tel"
                                            className="rounded-xl"
                                        />
                                    </Field>
                                    <Field label={t('email')}>
                                        <Input
                                            value={values.email}
                                            onChange={(e) => setFieldValue('email', e.target.value)}
                                            placeholder={t('email')}
                                            type="email"
                                            className="rounded-xl"
                                        />
                                    </Field>
                                </div>
                            </div>
                        )}
                    </Section>

                    <p className="text-xs text-color-400 italic text-center leading-relaxed">
                        {t('report description thank')}
                    </p>

                    <FormActions onCancel={onCancel} submitText="submit" isSubmitting={isSubmitting} isValid={isValid}/>
                </form>
            )}
        </Formik>
    )
}

// Tái dùng nguyên field component đã có trong formSchema (đăng ký cho FieldsFactory) thay vì viết
// lại - lấy component thuần ra gọi trực tiếp trong Section/Field mới, theo đúng convention ở
// docs/ui/form-layout.md ("Field phức tạp có sẵn - tái dùng nguyên"). Xem ví dụ: ProfileForm.js.
const FeedbackCategoryRawInput = formSchema.feedback_category.children[0].component
const TitleRawInput = formSchema.title.children[0].component
const DescriptionRawInput = formSchema.description.children[0].component
const ReplyTitleRawInput = formSchema.reply_title.children[0].component
const ReplyDescriptionRawInput = formSchema.reply_description.children[0].component
const StatusRawInput = formSchema.status.children[0].component
const PublicRawInput = formSchema.status.children[1].component

export const EditFeedbackForm = ({
    item,
    initialValues,
    onCancel = NullAsDefault,
    onSubmit = NullAsDefault,
}) => {
    const t = useTranslate();
    const {isSm} = useContext(LayoutContext)
    const status_options = [StatusTypes.PENDING__1, StatusTypes.CLOSED]

    const {photos = []} = initialValues ?? {}

    const _initialValues = {
        ...initialValues,
        feedback_category_id: getId(initialValues?.feedback_category),
        status_options: status_options.map(deepTranslate(t)),
        public_options: appFieldTypes.yesOrno.map(deepTranslate(t))
    }
    const validate = (values) => {
        let errors = {}
        _.forEach(['title', 'description'], (name) => {
            const value = _.get(values, name)
            if (_.isEmpty(value ?? undefined)) {
                errors[name] = t('required field')
            }
        })
        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={({...values}) => {
                const changes = shallowDiff(values, initialValues)
                onSubmit(_.omitBy(
                    {
                        ...changes,
                    },
                    _.isUndefined
                ))
            }}>
            {(formik) => {
                const {values, touched, errors, setFieldValue, handleSubmit, isSubmitting, isValid} = formik
                const onChange = (e) => setFieldValue(e.target.name, e.target.value)
                return (
                    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                        <Section icon={PiChatCircleTextFill} title={t('content feedback')} theme="highlight">
                            <Field label={t('your issue is')}>
                                <FeedbackCategoryRawInput
                                    name="feedback_category_id"
                                    value={values.feedback_category_id}
                                    form={formik}
                                    onChange={onChange}
                                />
                            </Field>
                            <Field label={t('title')} required error={touched.title && errors.title}>
                                <TitleRawInput name="title" value={values.title} form={formik} onChange={onChange}/>
                            </Field>
                            <Field label={t('description')} required error={touched.description && errors.description}>
                                <DescriptionRawInput name="description" value={values.description} form={formik} onChange={onChange}/>
                            </Field>
                        </Section>

                        {renderIf(
                            photos.length > 0,
                            <Section icon={IoImageOutline} title={t('attached image')}>
                                <FeedbackPhotoGallery photos={photos}/>
                            </Section>
                        )}

                        <Section icon={GoDotFill} title={t('responses')}>
                            <Field label={t('response title')}>
                                <ReplyTitleRawInput name="reply_title" value={values.reply_title} form={formik} onChange={onChange}/>
                            </Field>
                            <Field label={t('response content')}>
                                <ReplyDescriptionRawInput name="reply_description" value={values.reply_description} form={formik} onChange={onChange}/>
                            </Field>
                            <div className={classNames('grid gap-3', isSm ? 'grid-cols-1' : 'grid-cols-2')}>
                                <Field label={t('status')}>
                                    <StatusRawInput name="status" value={values.status} form={formik} onChange={onChange}/>
                                </Field>
                                <Field label={t('public')}>
                                    <PublicRawInput name="public" value={values.public} form={formik} onChange={onChange}/>
                                </Field>
                            </div>
                        </Section>

                        <FormActions onCancel={onCancel} submitText="responses" isSubmitting={isSubmitting} isValid={isValid}/>
                    </form>
                )
            }}
        </Formik>
    )
}


